import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {toast} from "react-toastify";
import {buildQueryString} from "../../utils/buildQueryString";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;
// https://api.wiseberryonline.com.au/api/v1/menu?name=repeat_type

export const getAllTodo = createAsyncThunk(
  "todo/getAll",
  async (
    {id, from, limit, status, to, type, team = false, sortBy = "dueToday"},
    {dispatch, rejectWithValue}
  ) => {
    try {
      let queryString;
      // debugger;
      if (team) {
        queryString = buildQueryString({
          from,
          limit,
          to,
          type,
          all_tasks: 1,
        });
      } else {
        queryString = buildQueryString({
          allocated_contact: id,
          from,
          limit,
          to,
          type,
          all_tasks: 1,
        });
      }
      const res = await api.get(`${WiseBerryAPIEnv}task?${queryString}`);

      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        dispatch(logout());
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

export const getRepeatType = createAsyncThunk(
  "todo/repeatType",
  async (_, {rejectWithValue}) => {
    try {
      const res = await api.get(`${WiseBerryAPIEnv}menu?name=repeat_type`);

      const newData = res.data.data.repeat_type.map((item) => {
        if (item.id === 1) {
          return {...item, name: "Never Repeat"};
        }
        return item;
      });
      return newData;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
export const getMember = createAsyncThunk(
  "todo/members",
  async (_, {rejectWithValue}) => {
    try {
      const res = await api.get(`${WiseBerryAPIEnv}member/team-members`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const addTodo = createAsyncThunk(
  "todo/add_todo",
  async (obj, {dispatch}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}task`, obj);

      if (res.data) {
        toast.success(res.data.message);
      }

      return res.data.data;
      //   dispatch(loadUser(res.data?.data?.original.data.contact_id));
    } catch (err) {
      if (err.response && err.response.data) {
        throw new Error(err.response.data.message);
      }
      throw new Error(err.message);
    }
  }
);

export const editTodo = createAsyncThunk(
  "todo/edit_todo",
  async (obj, {dispatch}) => {
    const {taskId, ...newObj} = obj;
    try {
      const res = await api.patch(`${WiseBerryAPIEnv}task/${taskId}`, newObj);

      if (res.data) {
        toast.success(res.data.message);
      }

      return res.data.data;
    } catch (err) {
      if (err.response && err.response.data) {
        throw new Error(err.response.data.message);
      }
      throw new Error(err.message);
    }
  }
);

export const completeTask = createAsyncThunk(
  "todo/complete-task",
  async (obj, {dispatch}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}task/complete`, obj);

      if (res.data) {
        toast.success(res.data.message);
      }

      return res.data.data;
      //   dispatch(loadUser(res.data?.data?.original.data.contact_id));
    } catch (err) {
      if (err.response && err.response.data) {
        throw new Error(err.response.data.message);
      }
      throw new Error(err.message);
    }
  }
);
export const DeleteTask = createAsyncThunk(
  "todo/delete-task",
  async (obj, {dispatch}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}task/bulk-delete`, obj);

      if (res.data) {
        toast.success(res.data.message);
      }

      return res.data.message;
      //   dispatch(loadUser(res.data?.data?.original.data.contact_id));
    } catch (err) {
      if (err.response && err.response.data) {
        throw new Error(err.response.data.message);
      }
      throw new Error(err.message);
    }
  }
);

let initialState = {
  todos: [],
  loading: false,
  todoError: null,
  repeatType: [],
  repeatTypeError: null,
  loadingRepeat: false,
  members: [],
  loadingMembers: false,
  membersError: null,
  newTask: {},
  newTaskError: null,
  loadingNewTask: false,
  completedTask: [],
  completedTaskError: null,
  loadingCompletedTask: false,
  editedTask: {},
  editedTaskError: null,
  editedLoadingTask: false,
  deletedTask: null,
  deletedTaskError: null,
  deletedLoadingTask: false,
};

const todoSlice = createSlice({
  name: "todo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTodo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllTodo.fulfilled, (state, action) => {
        state.todos = action.payload;
        state.loading = false;
        state.todoError = null;
      })
      .addCase(getAllTodo.rejected, (state, action) => {
        state.loading = false;
        state.todoError = action.payload;
        state.todos = [];
      })
      .addCase(getRepeatType.pending, (state) => {
        state.loadingRepeat = true;
      })
      .addCase(getRepeatType.fulfilled, (state, action) => {
        state.repeatType = action.payload;
        state.loadingRepeat = false;
        state.repeatTypeError = null;
      })
      .addCase(getRepeatType.rejected, (state, action) => {
        state.loadingRepeat = false;
        state.repeatTypeError = action.payload;
        state.repeatType = [];
      })
      .addCase(getMember.pending, (state) => {
        state.loadingMembers = true;
      })
      .addCase(getMember.fulfilled, (state, action) => {
        state.members = action.payload;
        state.loadingMembers = false;
        state.membersError = null;
      })
      .addCase(getMember.rejected, (state, action) => {
        state.loadingMembers = false;
        state.membersError = action.payload;
        state.members = [];
      })
      .addCase(addTodo.pending, (state) => {
        state.loadingNewTask = true;
      })
      .addCase(addTodo.fulfilled, (state, action) => {
        state.newTask = action.payload;
        state.loadingNewTask = false;
        state.newTaskError = null;
      })
      .addCase(addTodo.rejected, (state, action) => {
        state.loadingNewTask = false;
        state.newTaskError = action.payload;
        state.newTask = [];
      })
      .addCase(completeTask.pending, (state) => {
        state.loadingCompletedTask = true;
      })
      .addCase(completeTask.fulfilled, (state, action) => {
        state.completedTask = action.payload;
        state.loadingCompletedTask = false;
        state.completedTaskError = null;
      })
      .addCase(completeTask.rejected, (state, action) => {
        state.loadingCompletedTask = false;
        state.completedTaskError = action.payload;
        state.completedTask = [];
      })
      .addCase(editTodo.pending, (state) => {
        state.editedLoadingTask = true;
      })
      .addCase(editTodo.fulfilled, (state, action) => {
        state.editedTask = action.payload;
        state.editedLoadingTask = false;
        state.editedTaskError = null;
      })
      .addCase(editTodo.rejected, (state, action) => {
        state.editedLoadingTask = false;
        state.editedTaskError = action.payload;
        state.editedTask = {};
      })
      .addCase(DeleteTask.pending, (state) => {
        state.deletedLoadingTask = true;
      })
      .addCase(DeleteTask.fulfilled, (state, action) => {
        state.deletedTask = action.payload;
        state.deletedLoadingTask = false;
        state.deletedTaskError = null;
      })
      .addCase(DeleteTask.rejected, (state, action) => {
        state.deletedLoadingTask = false;
        state.deletedTaskError = action.payload;
        state.deletedTask = {};
      });
    // .addCase(logout?.fulfilled, (state, action) => {
    //   // Update state with data from the rejected action
    //   return initialState;
    // });
  },
});

export default todoSlice.reducer;
